import { ProfitAndLossData } from "../types/profit-and-loss-api";
import { api, withErrorHandling } from "./api";
import qs from "qs";

export const getProfitAndLoss = async (
  clientId: string,
  connectionIds: string[],
  fromYear: number,
  fromMonth: number,
  toYear: number,
  toMonth: number
): Promise<ProfitAndLossData> => {
  const response = await withErrorHandling(() =>
    api.get<ProfitAndLossData>(`/clients/${clientId}/report/profit-and-loss`, {
      params: {
        clientId,
        fromYear,
        fromMonth,
        toYear,
        toMonth,
        connectionIds: connectionIds[0],
      },
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "repeat" }),
    })
  );
  return response.data;
};
